import React from "react";
import { Elements } from "./main";
import queryString from "query-string";
import CardForm from "./CardForm";

function App() {
  const container = React.useMemo(
    () => queryString.parse(window.location.search),
    [window?.location?.search],
  );
  return (
    <Elements fanthon={container}>
      <CardForm fields={container} />
    </Elements>
  );
}

export default App;
